import React from 'react';
import { Image } from 'react-bootstrap';
import GoogleMapReact, { fitBounds } from 'google-map-react';

import bbox from '@turf/bbox';
import ReactDOM from 'react-dom';
import _ from 'lodash'

import config from '../../constants/config';
import colors from '../../constants/colors';
import { useImmer } from 'use-immer';
// const MODES = [
//     { name: 'Read Only', value: DrawControl.READ_ONLY },
//     { name: 'Select FEATURE', value: DrawControl.SELECT_FEATURE },
//     { name: 'Select Vertex', value: DrawControl.SELECT_VERTEX },
//     { name: 'Draw Path', value: DrawControl.DRAW_PATH },
//     { name: 'Draw Polygon', value: DrawControl.DRAW_POLYGON },
//     { name: 'Draw Point', value: DrawControl.DRAW_POINT }
// ];

// const MapGL = ReactMapboxGl({
//     accessToken:
//       config.keyMapBox
//   });

export interface ViewPortT {
    width: number | string
    height: string | number
    latitude: number
    longitude: number
    zoom: number
    bearing: number
    pitch: number
}
export interface MarkerT {

    title?: string
    description?: string
    coordinate: CoordinateT
    id?: number
    bgImage?: string
    pinImage?: string
    bgColor?: string
}
export interface CoordinateT {
    longitude: number
    latitude: number
}

export type IGoogleMapViewProps = {
    coordinate?: CoordinateT
    showSubMarkers?: boolean
    openSubMarkers?(id: number): void
    markers: Array<MarkerT>

    rotateEnabled?: boolean
    scrollZoom?: boolean
    showZoom?: boolean
    zoom?: number
    onApiLoaded?(): void
}

const GoogleMapView: React.FC<IGoogleMapViewProps> = (props) => {
    const forceUpdate = React.useState()[1].bind(null, {})  // see NOTE above
    const [isReady, setIsReady] = React.useState(false);

    const [state, setState] = useImmer({
        subMarkers: [],
        center: {
            lat: 37.7577,
            lng: -122.4376,
        },
        zoom: 11,
        isReady: false,
        showSubMarkers: false,
        mode: null,
        features: [],
        selectedId: null
    });

    const [googleMaps, setGoogleMaps] = React.useState(null);
    const [googleMap, setGoogleMap] = React.useState(null);
    const refMap = React.useRef(null);
    const gMap = React.useRef(null);
    React.useEffect(() => {
        setTimeout(() => {
            setIsReady(true)
        }, 1000);
    }, []);


    React.useEffect(() => {
        asyncFitBounds(props.markers)
    }, [props?.markers, googleMap, googleMaps]);


    const onMarkerClick = (id: number) => {
        if (!state.showSubMarkers && props.openSubMarkers) {
            props.openSubMarkers(id);
        }
    }

    const isValidMarker = (marker: MarkerT): boolean => {
        return (_.isNil(marker?.coordinate?.latitude) && _.isNil(marker?.coordinate?.longitude))
            || (marker?.coordinate?.latitude == 0 && marker?.coordinate?.longitude == 0) ? false : true

    }




    const bindResizeListener = (map, maps, bounds) => {
        console.log("markers->bindResizeListener->maps", maps)
        maps.event.addDomListenerOnce(map, "idle", () => {
            maps.event.addDomListener(window, "resize", () => {
                // map.fitBounds(bounds) // <= don't call this function
            })
        })
    }




    const asyncFitBounds = (markers: Array<MarkerT>) => {

        try {
            if (!_.isArray(markers)) {
                return null
            }
            if (!googleMaps?.LatLngBounds || !googleMap) {
                return null
            }
            const bounds = new googleMaps.LatLngBounds();
            for (const marker of markers) {

                if (isValidMarker(marker)) {
                    let latlng = new googleMaps.LatLng(Number(marker?.coordinate?.latitude), Number(marker?.coordinate?.longitude))
                    bounds.extend(latlng);
                }
            }
            // bounds.zoom = 10
           
            googleMap.fitBounds(bounds);
            // googleMap.setCenter(bounds.getCenter());

            // googleMap?.zoom=10.5
            let firstMarker = markers.length > 0 ? markers[0] : null
            /**
             * important for fix zoom 
             */
            setState((draft) => {
                draft.zoom = 10.5
                // draft.center = center
            })
        
        } catch (error) {
            console.log("error->asyncFitBounds", error)
        }
    }

    const handleApiLoaded = ({ map, maps, places }) => {
        setGoogleMaps(maps)
        setGoogleMap(map)
        if (props?.onApiLoaded) {
            props.onApiLoaded()
        }
    };

    const renderMakrer = (marker: MarkerT, index) => {

        if (!isValidMarker(marker)) {
            return null;
        }
        let bgImage = marker.bgImage
        let pinImage = marker.pinImage
        return (
            <div
                key={index}
                title={marker?.title ? marker?.title : ""}
                className='marker'
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    width: 50,
                    height: 50,
                    // backgroundColor: "#000",
                    // border: "2px solid #fff",
                    borderRadius: " 100%",
                    userSelect: "none",
                    textAlign: "center",
                    transform: "translate(-50%, -50%)",
                    cursor: "${(props) => (props.onClick ? 'pointer' : 'default')}",
                    // transform: 'translateZ(0) translate(-50%, -50%)',
                    // backfaceVisibility: 'hidden',
                    // zIndex: 999
                    // &:hover {
                    //   z-index: 1;
                    // }
                }}
                // @ts-ignore
                lat={Number(marker?.coordinate?.latitude)}
                // @ts-ignore
                lng={Number(marker?.coordinate?.longitude)}

                // pinColor={'peru'}
                onClick={() => {
                    console.log("onClick->marker", marker)
                    onMarkerClick(marker?.id)
                }}
            >
                <div style={{
                    position: "relative",
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    padding: 5,
                    borderRadius: 50,
                    backgroundImage: `url(${bgImage})`,
                    // backgroundColor: bgColor,
                    backgroundSize: 'cover',
                    backgroundPositionX: "center",
                    backgroundPositionY: "center",
                }}
                // @ts-ignore
                // lat={marker?.coordinate?.latitude}
                // @ts-ignore
                // lng={marker?.coordinate?.longitude}
                >
                    <div style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 8,
                        marginLeft: 5,
                        marginRight: 5,
                        // backgroundColor:colors.green,
                        // textAlign: "center"
                    }}>
                        <Image style={{ width: 20, height: 20, }}
                            onLoad={() => forceUpdate()}
                            src={pinImage} onClick={() => onMarkerClick(marker.id)} />
                    </div>
                </div>
            </div >
        )
    }


    /**
     * https://developers.google.com/maps/documentation/javascript/controls#ControlOptions
     */
    const createMapOptions = () => {
        return {
            maxZoom: 10.5,
        };
    }

    return (
        <div style={{ height: 400, width: '100%' }}>
            <GoogleMapReact
                ref={refMap}
                // minZoom={10}
                maxZoom={16}
                minZoomOverride
                bootstrapURLKeys={{ key: config.keyMap, libraries: ['places'], id: 'CUSTOM_SCRIPT_ID' }}
                center={state.center}
                yesIWantToUseGoogleMapApiInternals
                defaultCenter={{
                    lat: Number(props?.coordinate?.latitude),
                    lng: Number(props?.coordinate?.longitude),
                }}
                onChange={(data: { center, zoom, bounds, marginBounds }) => {
                    console.log("onChange", data)
                    console.log("zoom", data?.zoom)
                }}
                // resetBoundsOnResize={true}
                onGoogleApiLoaded={handleApiLoaded}
                zoom={state.zoom}
                defaultZoom={props?.zoom ? props?.zoom : 10}
                options={createMapOptions}
            // options={{
            //     restriction: {
            //         //  latLngBounds: {
            //         //      north: 19.137384, // Mumbai
            //         //      south: 18.510866, // Pune
            //         //      west: 72.874748,  // Mumbai
            //         //      east: 73.879864,  // Pune
            //         //   },
            //         strictBounds: false,
            //     }
            // }}
            >
                {props?.markers.map(renderMakrer)}
            </GoogleMapReact>
        </div>
    )
}



export default GoogleMapView;
